import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import useAuth from './useAuth';

const useAdminAuth = () => {
    const auth = useSelector((state) => state.user);


    if (auth?.accessToken && auth?.user && auth?.user?.role === 'admin') {
        return true;
    } else {
        return false;
    }
};

export default useAdminAuth;